import BlockQuote from './BlockQuote';

export default BlockQuote;
